﻿$.fn.dxCtrlChartHistoClick = function custom_dxCtrlChartHistoClick(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcharthistoclick dx-ctrl");
        this.createInstance(new cdxCtrlChartHistoClick(this, option));
    }
    return this;
}

window.cdxCtrlChartHistoClick = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "datacharthistoclick"

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    var dxChart = null
    var dxZoom = null
    var oldDs = null
    function mRempli(ds, maxDate) {
        if (dxChart == null) {
            container.empty()
            if (ds.length == 0) {
                $("<div>(aucun click)</div>").appendTo(container)
            } else {
                var series = [{
                    argumentField: 'dat',
                    valueField: 'nb',
                    type: 'bar',
                }]
                dxChart = $("<div/>").appendTo(container).dxChart({
                    palette: 'Harmony Light',
                    dataSource: ds,
                    height: "calc(100% - 120px)",
                    commonSeriesSettings: {
                        point: {
                            size: 7,
                        },
                    },
                    argumentAxis: {
                        aggregationInterval: { minutes:1}
                    },
                    tooltip: {
                        enabled: true,
                        location: 'edge',
                        customizeTooltip(arg) {
                            return {
                                text: arg.argument.toDDMMAA() + "<br/>" + arg.value + " click" + ((arg.value > 1) ? "s" : ""),
                            };
                        },
                    },
                    series: series,
                    legend: {
                        visible: false,
                    },
                }).dxChart("instance");

                //if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') {
                //    option.bddCtrl.utiCourantParaJson[option.context_grid] = [new Date(parametre.dateNow).addMonths(-2), parametre.dateNow]
                //} else {
                //    var nbDay = Math.abs(diffdate(new Date(option.bddCtrl.utiCourantParaJson[option.context_grid][0]), new Date(option.bddCtrl.utiCourantParaJson[option.context_grid][1]), "d"))
                //    option.bddCtrl.utiCourantParaJson[option.context_grid] = [new Date(maxDate).addDays(-nbDay), maxDate]
                //}
                dxZoom = $('<div/>').appendTo(container).dxRangeSelector({
                    value: [ds[0].dat, ds[ds.length - 1].dat],
                    size: {
                        height: 120,
                    },
                    margin: {
                        left: 10,
                    },
                    //scale: {
                    //    minorTickCount: 1,
                    //    minorTickInterval: 'day',
                    //    tickInterval: 'day',
                    //    minRange: 'week',
                    //    maxRange: 'month',
                    //},
                    sliderMarker: {
                        format: 'monthAndYear',
                    },
                    dataSource: ds,
                    chart: {
                        series: series,
                        palette: 'Harmony Light',
                    },
                    behavior: {
                        valueChangeMode: 'onHandleMove',
                    },
                    onValueChanged(e) {
                        //option.bddCtrl.utiCourantParaJson[option.context_grid] = e.value
                        //option.bddCtrl.mSaveParaJsonUtilisateur();
                        dxChart.getArgumentAxis().visualRange(e.value);
                    },
                }).dxRangeSelector("instance");
                //dxChart.getArgumentAxis().visualRange(option.bddCtrl.utiCourantParaJson[option.context_grid]);

                if (option.grid) { //dashboard
                    dxZoom.element().on("mousedown", function (e) {
                        option.grid.enableMove(false);
                        option.grid.enableResize(false);
                    })
                    dxZoom.element().on("mouseup", function (e) {
                        option.grid.enableMove(true);
                        option.grid.enableResize(true);
                    })
                }
                oldDs = ds
            }
        } else {
            if (JSON.stringify(oldDs) != JSON.stringify(ds)) {
                dxChart.option("dataSource", ds)
                dxZoom.option("dataSource", ds)
                oldDs = ds
            }
        }
    }

    this.mUpdate = function () {
        option.bddCtrl.mAjaxCall({ command: "gethistoclick", id_table_com:option.idTableCom, id_com: option.idCom }, function (data) {
            if (typeof data.lstclick == 'undefined') data.lstclick = []
            var maxDate = null
            data.lstclick.forEach(function (item) {
                item.nb = parseInt(item.nb)
                if (maxDate == null || maxDate < item.dat) maxDate = item.dat
            })
            mRempli(data.lstclick, maxDate)
        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}